import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })

Vue.config.productionTip = false

// Import firebase-initialize file
// => run this file to start firebase
import firebaseInit from './firebase/firebaseInit'
firebaseInit

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

// Configure router to listen to meta tag: requiresAuth
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !(await firebase.getCurrentUser())) {
    next('/')
  } else {
    next()
  }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
